import {
  AssemblyGoverningValueDocument,
  GetAssemblyPointOfInterestsDocument,
  GetOneAssemblyForBlistersDocument,
  GetRecommendationsForAssemblyDocument,
  SelectedPointOfInterestDocument,
  PointOfInterestsDocument,
  usePointOfInterestActivitySubscription,
} from '@/__generated__/graphql';
import { useApolloClient } from '@apollo/client';
import { useAtomValue } from 'jotai';
import { useGetStructureId } from '@/hooks/useGetStructureId';
import * as state from '@/components/Analysis/state';
import { RefetchCompleteCallback } from '@/types';

export const useLiveSyncAssemblyPois = (
  onRefetchComplete?: RefetchCompleteCallback,
  isEnabled = true
) => {
  const structureId = useGetStructureId();
  const selectedAssemblyId = useAtomValue(state.selectedAssemblyId);

  const client = useApolloClient();

  const skipSubscription = !isEnabled || !structureId || !selectedAssemblyId;

  usePointOfInterestActivitySubscription({
    variables: {
      structureId: structureId,
      assemblyId: selectedAssemblyId,
    },
    onData: ({ data: pointOfInterestActivity }) => {
      if (pointOfInterestActivity?.data?.pointOfInterestActivity) {
        client
          .refetchQueries({
            include: [
              SelectedPointOfInterestDocument,
              PointOfInterestsDocument,
              AssemblyGoverningValueDocument,
              GetRecommendationsForAssemblyDocument,
              GetOneAssemblyForBlistersDocument,
              GetAssemblyPointOfInterestsDocument,
            ],
          })
          .then(() => {
            if (onRefetchComplete) {
              onRefetchComplete();
            }
          });
      }
    },
    skip: skipSubscription,
  });
};

export default useLiveSyncAssemblyPois;
